import React, { useEffect, useState, memo } from 'react'
import ReactModal from 'react-modal'
import { ReactComponent as CloseModalIcon } from '../../assets/svg/CloseModalIcon.svg'
import { ANALYTICS_EVENTS } from '../../analytics/events'
import useTrackedSurface from '../../analytics/useTrackedSurface'
import { useTranslation } from 'react-i18next'
import '../../styles/common/ImageWithPlaceholder.css'

const BigImageModal = memo(({ modalIsOpen, closeModal, selectedImage }) => {
    const { t } = useTranslation()
    const [status, setStatus] = useState('loading')
    // This modal is memo'd and reused across opens, so the status has to be
    // reset per image or the second image inherits the first one's 'loaded'.
    useEffect(() => {
        setStatus('loading')
    }, [selectedImage])
    useTrackedSurface(ANALYTICS_EVENTS.DASHBOARD_CONTENT_RESULTS_IMAGE_VIEWED, {
        active: modalIsOpen,
        contentId: selectedImage,
        content: typeof selectedImage === 'string' ? selectedImage.split('/').pop()?.split('?')[0] : undefined,
    })
    useEffect(() => {
        ReactModal.setAppElement('#root')
    }, [])
    useEffect(() => {
        let element = document.getElementById('home')
        if (modalIsOpen) {
            if (element != null) {
                element.style.filter = 'blur(5px)'
            }
        }
        return () => {
            if (element != null) {
                element.style.filter = 'unset'
            }
        }
    }, [modalIsOpen])
    return (
        <ReactModal
            transparent
            isOpen={modalIsOpen}
            ariaHideApp={false}
            onAfterOpen={() => {}}
            onAfterClose={() => {}}
            onRequestClose={closeModal}
            style={{
                overlay: {
                    // Always the topmost layer: opened from inside other modals
                    // (content panels at 100, ConfirmationModal at 102).
                    zIndex: 105,
                },
                content: {
                    inset: 0,
                    padding: 0,
                    opacity: 1,
                    margin: 'auto',
                    marginTop: 30,
                    // width: 900,
                    backgroundColor: 'transparent',
                    maxHeight: '95%',
                    border: 'none',
                    borderRadius: 10,
                    boxShadow: 'none',
                    overflow: 'hidden',
                    position: 'relative',
                },
            }}
        >
            <div className="absolute top-0 w-full flex items-center justify-center ">
                <div
                    className="w-[60px] h-[60px] bg-deepPurple rounded-full cursor-pointer flex items-center justify-center z-[2] hover:bg-darkenPurple "
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        closeModal()
                    }}
                >
                    <CloseModalIcon />
                </div>
            </div>
            <div className="mt-[30px] flex justify-center items-center">
                {/* The frame reserves the region the full-resolution image will
                    fill, so the modal opens onto a skeleton instead of a void
                    and does not resize once the image arrives. */}
                <div
                    className="iwp-frame relative min-h-[50vh] max-h-[80vh] w-[60vw] max-w-[80vw]"
                    data-status={status}
                    aria-busy={status === 'loading'}
                >
                    {status === 'error' ? (
                        <div className="absolute inset-0 flex items-center justify-center text-mudPurple text-sm font-medium px-6 text-center">
                            {t('imageCouldNotBeLoaded')}
                        </div>
                    ) : (
                        <>
                            <div className="iwp-skeleton" aria-hidden="true" />
                            <img
                                className="iwp-img"
                                src={selectedImage}
                                alt=""
                                data-loaded={status === 'loaded'}
                                decoding="async"
                                onLoad={() => setStatus('loaded')}
                                onError={() => setStatus('error')}
                            />
                        </>
                    )}
                </div>
            </div>
        </ReactModal>
    )
})

export default BigImageModal
